import { useEffect, useState } from 'react';

import { convertsCurrencyToCents, debounce } from '@npi/buddy-utils';

export type HandleValueInCentsCallback = (valueInCents: number, valueInCurrency: number) => void;

export type UseConvertCurrencyToCentsProps = {
    amountInCurrency: number;
    handleValue?: HandleValueInCentsCallback;
    debounceDurationInMs?: number;
};

export function useConvertCurrencyToCentsDebounced({
    amountInCurrency,
    handleValue,
    debounceDurationInMs = 500,
}: UseConvertCurrencyToCentsProps) {
    const [amountInCents, setAmountInCents] = useState(0);

    useEffect(() => {
        if (handleValue && Math.round(amountInCents) === Math.round(amountInCurrency * 100)) {
            handleValue(amountInCents, amountInCurrency);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [amountInCents, handleValue]);

    useEffect(() => {
        const handleCurrencyToCents = (amountInCurrency: number) => {
            setAmountInCents(convertsCurrencyToCents(amountInCurrency));
        };

        const debouncedOnChange = debounce(() => {
            return handleCurrencyToCents(amountInCurrency);
        }, debounceDurationInMs);
        debouncedOnChange();

        return () => {
            debouncedOnChange.cancel();
        };
    }, [amountInCurrency, debounceDurationInMs]);

    return { amountInCents };
}

export default useConvertCurrencyToCentsDebounced;
